<template>
  <div class="form-group">
    <label :style="'color:'+template.style.surveyTextColor" class="title-bold" for="nome">{{ questionText }}</label>
    <vs-row
      vs-justify="flex-start"
      vs-type="flex"
      v-for="(ans, index) in l"
      v-bind:key="index"
      class="mb-3 survey-multitext-row"
    >
      <textarea
        class="form-control survey-multitext"
        rows="3"
        :placeholder="getPlaceHolder"
        :maxlength="maxChars || undefined"
        :style="template.style.surveyBgColor ? {backgroundColor: template.style.surveyBgColor, color: template.style.surveyTextColor} : {color: template.style.surveyTextColor}"
        v-model="l[index]"
        :disabled="processingApi"
        v-on:keyup.enter="enterKey(index)"
        v-on:input="onInput(index)"
      />
      <small
        v-if="maxChars"
        class="survey-multitext__counter"
        :style="{ color: template.style.surveyTextColor }"
      >
        {{ fieldLength(index) }}/{{ maxChars }}
      </small>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: "Survey-Multiple-Text",
  props: {
    questionText: { type: String },
    questionId: { type: Number },
    placeHolder: { type: String },
    config: { type: String, default: "" },
  },
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    nMax: 1,
    maxChars: null,
    l: [],
    processingApi: false,
  }),
  computed: {
    getPlaceHolder() {
      if (this.placeHolder) return this.placeHolder;
      return this.$t("type_answer_here");
    },
    template() {
      return this.$store.state.template;
    },
  },
  created() {
    this.parseConfig();

    for (let j = 0; j < this.nMax; j++) this.l.push("");

    this.qtAnwser = this.$store.getters.answerValue(this.questionId);

    if (this.$store.getters.answerValue(this.questionId)) {
      const answer = this.$store.getters.answerValue(this.questionId);
      const parts = answer.split(";");
      for (let i = 0; i < parts.length - 1; i++) {
        this.l[i] = this.limitText(parts[i]);
      }
    }
  },
  updated() {
    this.focusInput();
  },
  methods: {
    parseConfig() {
      if (!this.config) return;

      const opts = this.config.split(";");
      for (let i = 0; i < opts.length; i++) {
        if (opts[i].includes("n:")) {
          const value = opts[i].split(":")[1];
          this.nMax = Number(value) || 1;
        }
        if (opts[i].includes("max:")) {
          const value = opts[i].split(":")[1];
          this.maxChars = Number(value) || null;
        }
      }
    },
    limitText(value) {
      const text = String(value || "");
      if (!this.maxChars) return text;
      return text.slice(0, this.maxChars);
    },
    fieldLength(index) {
      return (this.l[index] || "").length;
    },
    mountAnswer() {
      let resp = "";
      for (let i = 0; i < this.l.length; i++) {
        if (this.l[i] !== "") resp = resp + this.l[i] + ";";
      }
      return resp;
    },
    focusInput() {
      if (this.$refs.fc && this.$refs.fc.$el) {
        this.$refs.fc.$el.focus();
      }
    },
    onInput(index) {
      if (this.maxChars) {
        this.l[index] = this.limitText(this.l[index]);
      }
      this.allKeys();
    },
    allKeys() {
      const resp = this.mountAnswer();
      this.$emit("AnswerChanged", resp, this.questionId);
    },
    enterKey(index) {
      if (index === this.l.length - 1) {
        const resp = this.mountAnswer();
        this.processingApi = true;
        this.$emit("QuestionAnwered", resp, this.questionId).then(
          () => (this.processingApi = false)
        );
      } else {
        const inputsRef = document.getElementsByTagName("input");
        inputsRef[index + 1].focus();
      }
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>

<style scoped>
.title-bold {
  font-family: "OxaniumBold";
}

.survey-multitext-row {
  flex-direction: column;
  width: 100%;
}

.survey-multitext {
  resize: vertical;
  min-height: 5.5rem;
  line-height: 1.4;
  width: 100%;
}

.survey-multitext__counter {
  display: block;
  width: 100%;
  margin-top: 0.35rem;
  text-align: right;
  opacity: 0.75;
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .survey-multitext {
    min-height: 14rem;
    max-height: none;
  }
}
</style>
